/**
 * Presentation-only grouping of screening matches.
 *
 * The same entity is listed by several authorities (OpenSanctions-derived
 * entity_ids are shared between UNSCR and EU Consolidated, for example), and
 * the API deliberately returns every listing. For a reviewer, one card per
 * entity that names every list it appears on reads far better than the same
 * party repeated four times. The API payload is never mutated.
 */
const SOURCE_PRIORITY = [
  'UNSCR',
  'OFAC SDN',
  'EU Consolidated',
  'MY MOHA Sanctions',
  'OpenSanctions',
  'OpenSanctions PEP',
];

const sourceRank = (source) => {
  const idx = SOURCE_PRIORITY.indexOf(source);
  return idx === -1 ? SOURCE_PRIORITY.length : idx;
};

export function groupMatchesByEntity(matches = []) {
  const groups = [];
  const index = new Map();

  matches.forEach((match) => {
    const entityId = match.details?.entity_id || match.entity_id;
    const key = entityId || `${match.matched_name}::${match.source}`;
    const existing = index.get(key);

    if (existing) {
      existing.listings.push(match);
      if (!existing.sources.includes(match.source)) {
        existing.sources.push(match.source);
        existing.sources.sort((a, b) => sourceRank(a) - sourceRank(b));
      }
      return;
    }

    const group = {
      key,
      entityId: entityId || null,
      // `matches` arrives sorted by risk band then score, so the first listing
      // seen for an entity is the strongest one.
      primary: match,
      listings: [match],
      sources: [match.source],
    };
    index.set(key, group);
    groups.push(group);
  });

  return groups;
}

export default groupMatchesByEntity;
